
import { getCurrentDate, getCurrentDateOfBelow, getCurrentYearOfFiveBelow } from "../../services/DateServices";

export default {
  contract: "",
  vesselName: "",
  testType: "",
  bunkerPort: "",
  bunkeredFromDate: getCurrentDateOfBelow(1830),
  bunkeredToDate: getCurrentDate(),
  customerKey: ""
}